<template>
    <div class="page-content">
        <div class="page-content__header">
            <UserHeadline title="UncompletedStudies.title">
                <HideFilters v-on:toggleFilters="toggleFilters" :filtersHidden="filtersHidden"/>
            </UserHeadline>
        </div>
        <div class="page-content__container">
            <UncompletedFilter
                :filtersHidden="filtersHidden"
                :uncompletedCourses="uncompletedCourses"
                :uncompletedLearningPaths="uncompletedLearningPaths"
                v-on:completed-courses-filtered="onFilterChange"
                :sorting="sorting"
                :learningPathSorting="learningPathSorting"
            />
            <div class="uncompleted-results">
                <div class="count-info" v-if="filteredLearningPaths.length !== 0 || limitedCollection.length !== 0">
                    <StudiesCountInfo
                        :studies="[...filteredLearningPaths, ...limitedCollection]"
                        :text="$t('UncompletedCourses.countAllInfoText')"
                        type="uncompleted"
                    />
                    <p class="page-content__description" v-html="$t('UncompletedStudies.description')"></p>
                </div>
                <div class="result-container" v-if="$totemLang !== 'dk'">
                    <UncompletedSorting
                        :uncompletedCourses="filteredLearningPaths"
                        v-on:sorting-changed="learningPathSortingChange"
                        :title="$t('UncompletedSorting.uncompletedLearningPaths')"
                        type="learningPaths"
                    >
                        <template v-slot="item">
                            <StudiesCountInfo
                                :studies="filteredLearningPaths"
                                :text="$t('UncompletedCourses.countLearningPathsInfoText')"
                                type="uncompleted"
                            />
                        </template>
                    </UncompletedSorting>
                    <LearningPathsList :learningPaths="filteredLearningPaths" v-if="filteredLearningPaths.length !== 0" class="uncompleted-results__content-list">
                        <template v-slot="item">
                            <TotemLearningPathItemMosaic :learningPath="item.learningPath" :index="item.index" :isUnCompletedView="true"/>
                        </template>
                    </LearningPathsList>
                    <TotemToast ref="toast" class="fixed-toast" />
                </div>
                <div class="result-container">
                    <UncompletedSorting
                        :uncompletedCourses="limitedCollection"
                        v-on:sorting-changed="sortingChange"
                        :title="$t('UncompletedSorting.uncompletedCourses')"
                        type="courses"
                    >
                        <template v-slot="item">
                            <StudiesCountInfo
                                :studies="limitedCollection"
                                :text="$t('UncompletedCourses.countCoursesInfoText')"
                                type="uncompleted"
                            />
                        </template>
                    </UncompletedSorting>
                    <UncompletedCourseList :courseList="limitedCollection" v-if="limitedCollection.length !== 0"  class="uncompleted-results__content-list">
                        <template v-slot="item">
                            <TotemCourseItemMosaic :course="item.course" :isUnCompletedView="true"/>
                        </template>
                    </UncompletedCourseList>
                    <TotemToast ref="toast" class="fixed-toast" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import uncompletedCourses from 'components/shared/mixins/uncompletedCourses'
    import UncompletedCourseList from 'components/user/uncompletedcourses/UncompletedCourseList'
    import LearningPathsList from 'components/user/items-listings/learningpathslist/LearningPathsList'
    import UncompletedFilter from 'components/user/uncompletedcourses/UncompletedFilter'
    import UncompletedSorting from 'components/user/uncompletedcourses/UncompletedSorting'
    import HideFilters from 'components/user/shared/HideFilters.vue'
    import UserHeadline from 'components/user/UserHeadline'
    import uncompletedLearningPaths from 'components/shared/mixins/uncompletedLearningPaths'
    import StudiesCountInfo from 'components/user/shared/StudiesCountInfo'

    export default {
        components: {
            UncompletedFilter,
            UncompletedCourseList,
            UncompletedSorting,
            UserHeadline,
            LearningPathsList,
            HideFilters,
            StudiesCountInfo
        },
        mixins: [ uncompletedCourses, uncompletedLearningPaths ],
        data () {
            return {
                filtersHidden: true
            }
        },
        methods: {
            toggleFilters () {
                this.filtersHidden = !this.filtersHidden
            },
            onFilterChange (filteredCourses, filteredLearningPaths) {
                this.onCourseListChange(filteredCourses)
                this.onLearningPathListChange(filteredLearningPaths)
            }
        },
        created () {
            this.$store.dispatch('CompletedCourses/loadCertificates')
            this.$store.dispatch('VideoLog/loadVideoLogs')
        }
    }
</script>

<style lang="scss" scoped>
.page-content {
    &--wide {
        padding: 10px 0 0;

        [class*="mobile"] & {
            padding: 30px 20px;
        }
    }

    &__header {
        display: flex;
        flex-direction: row;
        gap: 15px;
        align-items: center;
    }

    .uncompleted-results {
        display: flex;
        flex-direction: column;

        [class*="mobile_sm"] & {
            justify-content: center;
            align-items: center;
        }

        .fixed-toast {
            position: fixed;
            top: 80px;
        }

        .result-container {
            display: flex;
            flex-direction: column;
            gap: 30px;

            [class*="mobile_sm"] & {
                width: 100%;
            }
        }

        .count-info {
            display: flex;
            flex-direction: column;
            padding: 20px;
            background: $concrete;
            margin: 20px 0 30px 0;
            border-radius: 4px;
            gap: 15px;
        }

        &__content-list {
            margin-bottom: 50px;
        }
    }
}
</style>
